import { Component, Input, OnInit } from '@angular/core';
import { ContentDataByDataviewDTO, Table } from '@tj/tj-dmp-lib-api';
import { FieldService } from '../../../field/field/field.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'dmp-dyn-raw-detail-activities',
    templateUrl: './dyn-raw-detail-activities.component.html',
    styleUrls: ['./dyn-raw-detail-activities.component.scss'],
    standalone: false
})
export class DynRawDetailActivitiesComponent implements OnInit {

  @Input() data: ContentDataByDataviewDTO;
  @Input() tables: Table[];

  constructor(
    protected fieldService: FieldService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.fieldService.data = this.data;
    this.fieldService.tables = this.tables;
  }

  isActive(): boolean {
    if(this.data?.mainData.rows['personal.activity_status']){
      return this.data.mainData.rows['personal.activity_status'] === 'ACTIVE'
    }
    return false;
  }
  isInactive(): boolean {
    if(this.data?.mainData.rows['personal.activity_status']){
      return this.data.mainData.rows['personal.activity_status'] === 'INACTIVE'
    }
    return false;
  }
  isDormant(): boolean {
    if(this.data?.mainData.rows['personal.activity_status']){
      return this.data.mainData.rows['personal.activity_status'] === 'DORMANT'
    }
    return false;
  }
}
